import React from 'react';
import './donations.scss';
import { useTranslation } from 'react-i18next';

const Donations = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='containerDonation'>
                <div className='textDonations'>
                    {t('donations.title')}
                </div>
                <div className='textDirection'>
                    <div className='text1'>
                        {t('donations.checkText')}
                    </div>
                    <div className='text2'>
                        {t('donations.orgName')}
                    </div>
                    <div className='text3'>
                        {t('donations.address')}
                    </div>
                </div>
            </div>
        </>



    );
}

export default Donations;
